class HHAnimateScrollTo extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.onClick.bind(this))
    })

    window.addEventListener('scroll', this.onScroll.bind(this))
  }

  getOffset (hasHeaderHeight = true) {
    const rectOffset = document.querySelector('.js-scroll-nav')?.getBoundingClientRect()
    const offset = rectOffset?.height || 0
    return offset
  }

  getTargetElement (trigger) {
    if (!trigger) return
    const targetSelector = trigger.getAttribute('data-target') || trigger.getAttribute('href')
    if (targetSelector) {
      return document.querySelector(targetSelector)
    }
  }

  getElementTop (element, toScroll = false) {
    if (!element) return

    const { top } = element.getBoundingClientRect()
    const currentTop = window.pageYOffset || document.documentElement.scrollTop
    const headerHeight = parseInt(document.querySelector(':root').style.getPropertyValue('--hh-header-inner-height'))
    const announcmentBarHeight = parseInt(document.querySelector(':root').style.getPropertyValue('--hh-announcment-bar-height'))
    if (toScroll && (top > 0)) {
      return top + window.scrollY - this.getOffset() - headerHeight + announcmentBarHeight
    } else {
      return top + window.scrollY - this.getOffset() - headerHeight
    }
  }

  onClick(e) {
    e?.preventDefault()

    const targetElement = this.getTargetElement(e.currentTarget)
    if (targetElement) {
      window.scrollTo({
        top: this.getElementTop(targetElement, true),
        behavior: 'smooth'
      })
    }
  }

  onScroll(e) {
    const offset = this.getOffset()
    const headerHeight = parseInt(document.querySelector(':root').style.getPropertyValue('--hh-header-visible-height'))
    const currentTop = window.pageYOffset || document.documentElement.scrollTop
    let activeElement = this.triggers[0]
    this.triggers.forEach(trigger => {
      const content = this.getTargetElement(trigger)
      const { top } = content?.getBoundingClientRect() || { top: 0 }
      if ((top + window.scrollY - this.getOffset() - headerHeight - 10) <= currentTop) {
        activeElement = trigger
      }
    })

    this.triggers.forEach(trigger => {
      if (trigger == activeElement) {
        trigger.classList.add('active')
      } else {
        trigger.classList.remove('active')
      }
    })
  }

  get triggers () {
    return this.querySelectorAll('.js-trigger')
  }
}

window.customElements.define('hh-animate-scroll-to', HHAnimateScrollTo)
